import styled from '@emotion/styled/macro';
import { Variables } from '@enter/core';
import { BaseButton } from '@enter/core';

export const Wrapper = styled.div`
    padding: 24px;
`;

export const Title = styled.h1`
    font-size: 24px;
    font-weight: 600;
    color: ${Variables.Colors.n70};
    margin-bottom: 24px;
`;

export const HeaderRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    gap: 16px;
    flex-wrap: wrap;
`;

export const HeaderActions = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
`;

export const ActionButton = styled(BaseButton)`
    background: transparent;
    border: none;
    border-radius: 4px;
    padding: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: auto;
    color: #6c757d;
    
    &:hover {
        background-color: ${Variables.Colors.n5};
    }
    
    svg {
        color: #6c757d;
    }
`;

export const BadgesContainer = styled.div`
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    align-items: center;
    flex: 1;
`;

export const Content = styled.div`
    color: ${Variables.Colors.n50};
    padding: 10px 0 20px 0;
`;

export const TableSection = styled.div`
    margin-bottom: 20px;
`;

export const LoadingMessage = styled.div`
    padding: 40px;
    text-align: center;
    color: ${Variables.Colors.n50};
    font-size: 16px;
`;

export const ErrorMessage = styled.div`
    padding: 40px;
    text-align: center;
    color: ${Variables.Colors.warning};
    font-size: 16px;
`;

